import {axiosInstance} from "@/plugins/axios";

export async function getAgreementGroup(id: string) {
  const response = await axiosInstance.get(`agreement_groups/${id}`);
  return response.data;
}

export async function getAgreementGroups() {
  const response = await axiosInstance.get(`agreement_groups`);
  return response.data;
}
